<template>
  <div class="footerBox">
    <div class="footerPageBox hidden-sm-and-down">
      <div class="footerPageLaft">
        <div class="footer_top">
          <img
            class="footerLogoImg"
            src="@/assets/images/logo.png"
            alt="LogoImg"
          />
          <div class="footerMenuBox">
            <div class="footerMenuText" @click="handleSelect('1')">
              {{ $t("route.Home") }}
            </div>
            <div class="footerMenuText" @click="handleSelect('3')">
              {{ $t("route.companyProfile") }}
            </div>
            <div class="footerMenuText" @click="handleSelect('7')">
              {{ $t("route.newsInformation") }}
            </div>
            <div class="footerMenuText" @click="handleSelect('2')">
              {{ $t("route.ProductCenter") }}
            </div>
            <div class="footerMenuText" @click="handleSelect('5')">
              {{ $t("route.Pilot") }}
            </div>
            <!-- <div class="footerMenuText" @click="handleSelect('4')">
              {{ $t("route.ResourceLibrary") }}
            </div> -->
            <div class="footerMenuText" @click="handleSelect('6')">
              {{ $t("route.Contact") }}
            </div>
            <div class="footerMenuText" @click="handleSelect('8')">
              {{ $t("legalAndMap.legalStatement") }}
            </div>
            <div class="footerMenuText" @click="handleSelect('9')">
              {{ $t("legalAndMap.siteMap") }}
            </div>
          </div>
          <!-- <div class="footLine"></div> -->
        </div>
        <div class="footer_bottom">
          <div>{{ $t("footer.companyName") }}</div>
          <template v-if="language === 'zh'">
            &nbsp&nbsp&nbsp
            <div>粤ICP备09151866号-1</div>
            &nbsp&nbsp&nbsp
            <div class="footer_bottom_logo">
              <img
                class="beian"
                src="@/assets/images/icon/beian.png"
              />粤公网安备44049002000428号
            </div>
          </template>
        </div>
      </div>
      <div class="footerPageRight_qrCode">
        <!-- <img class="qrcode" src="@/assets/images/qrcode.png"> -->
        <img class="qrcode-hover" :src="temp.wechat_official_accounts_pic" />
        <img class="qrcode" :src="temp.wechat_official_accounts_pic" />
        <div class="qrcodeText">{{ $t("footer.officialWeChat") }}</div>
      </div>
      <div class="footerPageRight_qrCode">
        <!-- <img class="qrcode" src="@/assets/images/qrcode.png"> -->
        <img class="qrcode-hover" :src="temp.video_public_qr_pic" />
        <img class="qrcode" :src="temp.video_public_qr_pic" />
        <div class="qrcodeText">{{ $t("footer.officialVideo") }}</div>
      </div>
      <div class="footerPageRight_qrCode">
        <!-- <img class="qrcode" src="@/assets/images/qrcode.png"> -->
        <img class="qrcode-hover" :src="temp.douyin_public_qr_pic" />
        <img class="qrcode" :src="temp.douyin_public_qr_pic" />
        <div class="qrcodeText">{{ $t("footer.officialTiktok") }}</div>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="footerPageBox hidden-md-and-up">
      <div class="footerMobelBox">
        <img
          class="footerLogoImg"
          src="@/assets/images/logo.png"
          alt="LogoImg"
        />
        <div class="footerPageRight_list">
          <div class="footerPageRight_qrCode">
            <img class="qrcode" :src="temp.wechat_official_accounts_pic" />
            <div class="qrcodeText">{{ $t("footer.officialWeChat") }}</div>
          </div>
          <div class="footerPageRight_qrCode">
            <img class="qrcode" :src="temp.video_public_qr_pic" />
            <div class="qrcodeText">{{ $t("footer.officialVideo") }}</div>
          </div>
          <div class="footerPageRight_qrCode">
            <img class="qrcode" :src="temp.douyin_public_qr_pic" />
            <div class="qrcodeText">{{ $t("footer.officialTiktok") }}</div>
          </div>
        </div>
        <div class="footer_bottom">
          <div>{{ $t("footer.companyName") }}</div>
          <template v-if="language === 'zh'">
            &nbsp&nbsp&nbsp
            <div>粤ICP备09151866号-1</div>
            &nbsp&nbsp&nbsp
            <div class="footer_bottom_logo">
              <img
                class="beian"
                src="@/assets/images/icon/beian.png"
              />粤公网安备44049002000428号
            </div>
          </template>
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>

<script>
import { localStorage } from "../utils/storage.js";
export default {
  name: "footerPage",
  props: {
    msg: String,
  },
  data() {
    return {
      temp: {},
    };
  },
  computed: {
    language() {
      return localStorage.get("language") || "zh";
    },
  },
  created() {
    this.$store.dispatch("user/getInfo").then((res) => {
      this.temp = this.$store.getters.baseParameter;
    });
  },
  mounted() {},
  methods: {
    // 导航菜单选中
    handleSelect(key) {
      this.$emit("resetScrollTop");
      const type = {
        1: { name: "首页", path: "/" },
        2: { name: "产品与服务", path: "/product" },
        3: { name: "关于我们", path: "/companyProfile/3004" },
        4: { name: "资源库中心", path: "/resourceCenter" },
        5: { name: "客户服务", path: "/pilotService" },
        6: { name: "联系我们", path: "/ContactUs" },
        7: { name: "新闻信息", path: "/newsInformation" },
        8: { name: "法律声明", path: "/legalStatement" },
        9: { name: "网站地图", path: "/legalStatement/siteMap" },
      };
      // localStorage.set("menu", type[key].path);
      this.$router.push({ path: type[key].path });
    },
  },
};
</script>

<style scoped>
.footerPageBox {
  width: 100%;
  /* height: 100px; */
  box-sizing: border-box;
  background: #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer_top {
  width: 100%;
  /* height: 60px; */
  /* display: flex;
  align-items: center;
  justify-content: center; */
}
.footerLogoImg {
  width: auto;
  height: 60px;
  float: left;
  margin-bottom: -10px;
}
.footerMenuBox {
  margin-top: 25px;
  margin-left: 10px;
  display: flex;
  padding-bottom: 20px;
  border-bottom: 1px solid #dfdfdf;
}
.footerMenuText {
  display: inline-block;
  font-size: 14px;
  color: #333333;
  text-align: center;
  padding: 0 20px;
  border-right: 1px solid #dfdfdf;
  cursor: pointer;
}
.footerMenuText:last-child {
  border: 0;
}
.footerMenuText:active {
  color: #32589f;
}
.footLine {
  /* width: 800px; */
  height: 1px;
  background: #dfdfdf;
  margin: 0 auto;
}
.footer_bottom {
  width: 100%;
  height: 39px;
  line-height: 39px;
  margin-left: 80px;
  /* text-align: center; */
  font-size: 12px;
  color: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footerPageRight_qrCode {
  width: 80px;
  margin-left: 10px;
}
.footerPageRight_qrCode:hover .qrcode-hover {
  display: inline-block;
}
.qrcode-hover {
  display: none;
  width: 150px;
  position: absolute;
  bottom: 120px;
  border: 1px solid #dfdfdf;
}
.qrcode-hover:hover {
  display: none;
}
.qrcode {
  width: 65px;
  height: auto;
  margin: 0 auto 5px;
  cursor: pointer;
}
.qrcodeText {
  width: 100%;
  font-size: 13px;
  color: #333333;
  text-align: center;
}
.footer_bottom_logo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.beian {
  width: 20px;
  height: 20px;
}
@media only screen and (max-width: 992px) {
  .footerPageBox {
    height: auto;
  }
  .footerMobelBox {
    background: #f4f4f4;
  }

  .footerMobelBox {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .footer_bottom {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    line-height: 1.3;
    padding: 10px 30px;
    display: block;
    text-align: center;
    margin-left: 0;
  }
  .footerMobelBox .footerLogoImg {
    width: 150px;
    height: auto;
    float: none;
    margin: 10px 0;
    /* margin-bottom: 0; */
  }
  .footerMobelBox .qrcode {
    width: 100%;
    height: auto;
  }
  .footerPageRight_list {
    display: flex;
    column-gap: 15px;
  }
  .footerMobelBox .footerPageRight_qrCode {
    width: 100px;
    margin: 0;
  }
}
</style>